import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  line-height: 1;\n  margin-left: -', ';\n  margin-right: -', ';\n\n  > * {\n    margin-bottom: ', ';\n    padding-left: ', ';\n    padding-right: ', ';\n  }\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  line-height: 1;\n  margin-left: -', ';\n  margin-right: -', ';\n\n  > * {\n    margin-bottom: ', ';\n    padding-left: ', ';\n    padding-right: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  line-height: 1;\n  /* Balance the negative margin of the children */\n  margin-right: ', 'px;\n\n  > * {\n    margin-right: -', 'px;\n  }\n'], ['\n  display: flex;\n  line-height: 1;\n  /* Balance the negative margin of the children */\n  margin-right: ', 'px;\n\n  > * {\n    margin-right: -', 'px;\n  }\n']);

import styled from 'styled-components';
import { colors, gridSize } from '@atlaskit/theme';
import { BORDER_WIDTH } from './constants';

// TODO: use math utilities within styled component
var gutterUnitless = gridSize() / 2;
var gutter = gutterUnitless + 'px';

export var Grid = styled.div(_templateObject, gutter, gutter, gridSize, gutter, gutter);

export var Stack = styled.div(_templateObject2, function (props) {
  return BORDER_WIDTH[props.size] * 2 + gutterUnitless;
}, function (props) {
  return BORDER_WIDTH[props.size] * 2 + gutterUnitless;
});

export function getBackgroundColor(_ref) {
  var isActive = _ref.isActive,
      isHover = _ref.isHover;

  var themedBackgroundColor = colors.backgroundOnLayer;

  if (isHover) {
    themedBackgroundColor = colors.backgroundHover;
  }

  if (isActive) {
    themedBackgroundColor = colors.backgroundActive;
  }

  return themedBackgroundColor;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/avatar/dist/esm/styled/AvatarGroup.js
// module id = 185
// module chunks = 0